// extracted by mini-css-extract-plugin
module.exports = {"form_message":"RegistrationForm-module--form_message--3e_0m","registration_form_container":"RegistrationForm-module--registration_form_container--2zCp4"};